import { Loja, LojaFilters } from "../types/loja";
import { LojaFormData } from "../lib/validations";
import { apiClient } from "./apiClient";

export const lojaService = {
  getLojas: async (filters?: LojaFilters): Promise<Loja[]> => {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value) params.append(key, value.toString());
      });
    }
    const url = `/lojas${params.toString() ? `?${params.toString()}` : ""}`;
    return apiClient.get(url);
  },

  getLojaById: async (id: number): Promise<Loja> => {
    return apiClient.get(`/lojas/${id}`);
  },

  createLoja: async (data: LojaFormData): Promise<Loja> => {
    return apiClient.post("/lojas", data);
  },

  updateLoja: async (id: number, data: LojaFormData): Promise<Loja> => {
    return apiClient.put(`/lojas/${id}`, data);
  },

  deleteLoja: async (id: number): Promise<void> => {
    return apiClient.delete(`/lojas/${id}`);
  },
};
